document.addEventListener('DOMContentLoaded', function() {
    if (typeof Bundler !== 'undefined') {
        Bundler.init({
        targetElementId: 'bundler-target-element',
        // Add any additional configuration here
        });
    }
});

if (typeof window.bndlr !== 'undefined' && typeof window.bndlr.refresh === 'function') {
    window.bndlr.refresh();
}